import { Task, TaskControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  task: Task;
  xTENANTID?: string;
}

export const useAddTask = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskControllerApi(getConfigObject()).createTask(
      params.task,
      params.xTENANTID
    )
  );
